import React from 'react';

// DEPENDENCIES
import { useLocation } from 'react-router';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// STYLES
import styles from './pageHeader.module.scss';

// MAIN COMPONENT
const PageHeader = ({
  title,
  backPathname,
  headerTools,
  headerRight
}) => {
  const location = useLocation();

  return !title ? null : (
    <>
      <header className={styles.header}>
        {!!backPathname && (
          <Button.Link
            className={styles.backButton}
            variant="custom"
            icon="chevron-left"
            to={backPathname}
            square={false}
            state={location.state}
          />
        )}
        <div className={styles.container}>
          <h3 className={styles.title}>{title}</h3>
          {headerTools}
        </div>
        {!!headerRight && <div className="ms-3">{headerRight}</div>}
      </header>
      <hr className={styles.divider} />
    </>
  );
}

// EXPORT
export default PageHeader;
